import React from "react";
import { createRoot } from "react-dom/client";
import FeedbackDialog from "./index.jsx";
import FeedbackTypeEnum from "./feedbackType.ts"

export default class FeedbackController {

  root = null;
  element = null;
  isOpen = false;

  constructor() {
    this.element = document.createElement("div");
    document.body.appendChild(this.element);
    this.handleClose = () => {
      this.isOpen = false;
      if (this.root) {
        this.root.unmount();
        this.root = null;
      }
      if (this.element && document.body.contains(this.element)) {
        document.body.removeChild(this.element);
      }
    };
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new FeedbackController();
    }
    return this.instance;
  }

  async openFeedbackDialog(type = FeedbackTypeEnum.Feedback, param = null) {
    if (this.isOpen) 
      return;
    this.isOpen = true;
    try {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      this.root.render(
        React.createElement(FeedbackDialog, {
          type,
          param,
          open: true,
          closeFn: this.handleClose,
        })
      );
    } catch (error) {
      this.isOpen = false;
      console.error("Failed to render feedback dialog:", error);
    }
  }
}